import type { Middleware } from '@reduxjs/toolkit';

/**
 * Batches high-frequency actions (e.g. IoT data at 60fps) into single dispatch cycles
 * using requestAnimationFrame. Prevents excessive re-renders for real-time data streams.
 */
const BATCH_ACTION_TYPES = new Set(['realtime/dataReceived']);

export const performanceMiddleware: Middleware = () => {
  let pendingActions: { type: string; payload: unknown }[] = [];
  let frameId: number | null = null;

  return (next) => (action) => {
    const typedAction = action as { type: string; payload: unknown };

    if (BATCH_ACTION_TYPES.has(typedAction.type)) {
      pendingActions.push(typedAction);

      if (frameId === null) {
        frameId = requestAnimationFrame(() => {
          const batch = pendingActions;
          pendingActions = [];
          frameId = null;

          if (batch.length === 1) {
            next(batch[0]);
          } else if (batch.length > 1) {
            next({
              type: 'realtime/batchDataReceived',
              payload: batch.map((a) => a.payload),
            });
          }
        });
      }
      return;
    }

    return next(action);
  };
};
